import { Password } from '@mui/icons-material';
import { transparentize } from 'polished';
import styled from 'styled-components';

export const RadioBoxStyle = { m: 0.2, height: '40px', width: '150px', border: '0.5px solid #838383', borderRadius: '10px' };

export const Container =  styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: auto;
  width: 100%;
  max-width: 800px;

  ${({ theme }) => theme.breakpoints.up('xs')} {
    padding: 15px;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 0 35px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 0 98px;
  }
`;


export const ForgotPasswordContainer = styled.section`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-start;
  width: 100%;
  margin-top: 40px;
`;

export const FormContainer = styled.form`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 50px;
`;

export const FormGroup = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 40px;
`;

export const VerifyEmailContainer = styled.section`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-start;
  width: 100%;
  margin-top: 40px;
`;

export const PasswordIcon = styled(Password)`
  height: 30px;
`;

export const Block = styled.div`
  width: 308px
  height: 118px
  top: 251px
  background-color: red;
  left: 93px
  border-radius: 15px
  border: 2px solid #000;
`;